import React, { Suspense, lazy, useState } from 'react';
import { hasAdminHint } from '../../utils/adminHint';

// Chunk riêng: Firebase Auth + form chỉnh sửa + trình nén ảnh. Khách xem trang
// không bao giờ chạm tới, nên đừng import tĩnh ở đây.
const InlineEditProvider = lazy(() => import('./InlineEditProvider'));

/**
 * Bọc quanh phần nội dung có thể sửa được của trang công khai.
 *
 * Trình duyệt chưa từng đăng nhập admin thì đây chỉ là một hàm trả về
 * `children` — không thêm provider, không thêm byte nào vào bundle chính.
 *
 * `onSaved(app)` được gọi sau khi lưu thành công để trang cập nhật danh sách
 * ngay, không phải tải lại.
 */
const EditModeGate = ({ children, onSaved }) => {
    // Đọc một lần lúc mount: cờ đổi giữa chừng cũng không nên làm nháy giao diện.
    const [enabled] = useState(hasAdminHint);

    if (!enabled) return <>{children}</>;

    return (
        <Suspense fallback={<>{children}</>}>
            <InlineEditProvider onSaved={onSaved}>{children}</InlineEditProvider>
        </Suspense>
    );
};

export default EditModeGate;
